/* eslint-disable no-param-reassign */ import { isBrowser } from "../const/globalThis";
var SameSite;
(function(SameSite) {
    SameSite["strict"] = "strict";
    SameSite["lax"] = "lax";
})(SameSite || (SameSite = {}));
function setCookie(key, value) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_path = _ref.path, path = _ref_path === void 0 ? "/" : _ref_path, domain = _ref.domain, expires = _ref.expires, _ref_maxAge = _ref.maxAge, maxAge = _ref_maxAge === void 0 ? 60 * 60 * 24 * 30 : _ref_maxAge, secure = _ref.secure, sameSite = _ref.sameSite;
    if (!key) return;
    value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
    key = encodeURIComponent(String(key));
    key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
    key = key.replace(/[()]/g, escape);
    var attrs = [];
    if (path) attrs.push("path=".concat(path)); // path 非常重要, 默认是  location.pathname , 在删除或者修改 cookie 时候, path 没有对齐是无法修改 cookie 的.
    if (domain) attrs.push("domain=".concat(domain));
    if (expires) attrs.push("expires=".concat(expires));
    if (maxAge) attrs.push("max-age=".concat(maxAge)); // important:"max-age" is not supported by IE6/7/8
    if (secure) attrs.push("secure");
    if (sameSite) attrs.push("samesite=".concat(sameSite));
    if (isBrowser) document.cookie = "".concat(key, "=").concat(value, ";").concat(attrs.join(";"));
}
// 为确保获取到相对正确的cookie值，使用domain作为排序的依据
function getCookie(key) {
    if (isBrowser) {
        var _document_cookie;
        var cookies = ((_document_cookie = document.cookie) === null || _document_cookie === void 0 ? void 0 : _document_cookie.split("; ")) || [];
        var REDCode = /(%[0-9A-Z]{2})+/g;
        var domainPart = "domain=".concat(location.hostname);
        cookies.sort(function(a) {
            return a.includes(domainPart) ? -1 : 0;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cookie = _step.value;
                var parts = cookie.split("=");
                try {
                    if (key === parts[0].replace(REDCode, decodeURIComponent)) {
                        return parts.slice(1).join("=").replace(REDCode, decodeURIComponent);
                    }
                } catch (e) {
                // do nothing
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return "";
}
export { setCookie, getCookie };
